/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: oYWs1jXLUht24zyQBdCd5F
// Component: dWRKivg8dUht

import * as React from "react";

import {
  Flex as Flex__,
  SingleChoiceArg,
  StrictProps,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "../../../plasmic/plasmic_kit_init_token/PlasmicStyleTokensProvider"; // plasmic-import: oYWs1jXLUht24zyQBdCd5F/styleTokensProvider
import Button from "../../widgets/Button"; // plasmic-import: SEF-sRmSoqV5c/component

import "@plasmicapp/react-web/lib/plasmic.css";

import "../../../plasmic/PP__plasmickit_init_token.css"; // plasmic-import: oYWs1jXLUht24zyQBdCd5F/projectcss
import sty from "./PlasmicInitTokenContainer.module.css"; // plasmic-import: dWRKivg8dUht/css

createPlasmicElementProxy;

export type PlasmicInitTokenContainer__VariantMembers = {
  state: "loading" | "error" | "done";
};
export type PlasmicInitTokenContainer__VariantsArgs = {
  state?: SingleChoiceArg<"loading" | "error" | "done">;
};
type VariantPropType = keyof PlasmicInitTokenContainer__VariantsArgs;
export const PlasmicInitTokenContainer__VariantProps =
  new Array<VariantPropType>("state");

export type PlasmicInitTokenContainer__ArgsType = { avatarImgUrl?: string };
type ArgPropType = keyof PlasmicInitTokenContainer__ArgsType;
export const PlasmicInitTokenContainer__ArgProps = new Array<ArgPropType>(
  "avatarImgUrl"
);

export type PlasmicInitTokenContainer__OverridesType = {
  root?: Flex__<"div">;
  freeBox?: Flex__<"div">;
  authorizeButton?: Flex__<typeof Button>;
};

export interface DefaultInitTokenContainerProps {
  avatarImgUrl?: string;
  state?: SingleChoiceArg<"loading" | "error" | "done">;
  className?: string;
}

const $$ = {};

function PlasmicInitTokenContainer__RenderFunc(props: {
  variants: PlasmicInitTokenContainer__VariantsArgs;
  args: PlasmicInitTokenContainer__ArgsType;
  overrides: PlasmicInitTokenContainer__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "state",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.state,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_oYWs1jXLUht24zyQBdCd5F",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootstate_done]: hasVariant($state, "state", "done"),
          [sty.rootstate_error]: hasVariant($state, "state", "error"),
          [sty.rootstate_loading]: hasVariant($state, "state", "loading"),
        }
      )}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames("all", sty.freeBox)}
      >
        <div
          className={classNames("all", "__wab_text", sty.text__iGeHa, {
            [sty.textstate_done__iGeHajSd8X]: hasVariant(
              $state,
              "state",
              "done"
            ),
            [sty.textstate_loading__iGeHaw4Rpw]: hasVariant(
              $state,
              "state",
              "loading"
            ),
          })}
        >
          {"Authorize Plasmic CLI"}
        </div>
        <div
          className={classNames("all", "__wab_text", sty.text__v6QVe, {
            [sty.textstate_done__v6QVejSd8X]: hasVariant(
              $state,
              "state",
              "done"
            ),
            [sty.textstate_error__v6QVejArRi]: hasVariant(
              $state,
              "state",
              "error"
            ),
          })}
        >
          {hasVariant($state, "state", "done")
            ? "Done! You may now close this tab."
            : hasVariant($state, "state", "error")
            ? "Do you want to authorize Plasmic CLI to have access to your projects?"
            : "Do you want to authorize Plasmic CLI to have access to your projects?"}
        </div>
      </div>
      {(hasVariant($state, "state", "done") ? false : true) ? (
        <Button
          data-plasmic-name={"authorizeButton"}
          data-plasmic-override={overrides.authorizeButton}
          className={classNames("__wab_instance", sty.authorizeButton, {
            [sty.authorizeButtonstate_done]: hasVariant(
              $state,
              "state",
              "done"
            ),
            [sty.authorizeButtonstate_error]: hasVariant(
              $state,
              "state",
              "error"
            ),
            [sty.authorizeButtonstate_loading]: hasVariant(
              $state,
              "state",
              "loading"
            ),
          })}
          disabled={hasVariant($state, "state", "loading") ? true : undefined}
          size={"wide"}
          startIcon={null}
          type={["primary"]}
        >
          <div
            className={classNames("all", "__wab_text", sty.text__imVdJ, {
              [sty.textstate_loading__imVdJw4Rpw]: hasVariant(
                $state,
                "state",
                "loading"
              ),
            })}
          >
            {hasVariant($state, "state", "loading")
              ? "Loading..."
              : "Authorize"}
          </div>
        </Button>
      ) : null}
      {(hasVariant($state, "state", "error") ? true : false) ? (
        <div
          className={classNames("all", "__wab_text", sty.text__km2Ku, {
            [sty.textstate_done__km2KujSd8X]: hasVariant(
              $state,
              "state",
              "done"
            ),
            [sty.textstate_error__km2KujArRi]: hasVariant(
              $state,
              "state",
              "error"
            ),
          })}
        >
          {hasVariant($state, "state", "error")
            ? "Authorization error. Please try again."
            : ""}
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox", "authorizeButton"],
  freeBox: ["freeBox"],
  authorizeButton: ["authorizeButton"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
  authorizeButton: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicInitTokenContainer__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicInitTokenContainer__VariantsArgs;
    args?: PlasmicInitTokenContainer__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicInitTokenContainer__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicInitTokenContainer__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicInitTokenContainer__ArgProps,
          internalVariantPropNames: PlasmicInitTokenContainer__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicInitTokenContainer__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicInitTokenContainer";
  } else {
    func.displayName = `PlasmicInitTokenContainer.${nodeName}`;
  }
  return func;
}

export const PlasmicInitTokenContainer = Object.assign(
  // Top-level PlasmicInitTokenContainer renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    authorizeButton: makeNodeComponent("authorizeButton"),

    // Metadata about props expected for PlasmicInitTokenContainer
    internalVariantProps: PlasmicInitTokenContainer__VariantProps,
    internalArgProps: PlasmicInitTokenContainer__ArgProps,
  }
);

export default PlasmicInitTokenContainer;
/* prettier-ignore-end */
